import React from 'react';
import MailList from '../components/MailList';
import MailViewer from '../components/MailViewer';
import ComposeModal from '../components/ComposeModal';
import ContextMenu from '../components/ContextMenu';
import { Shield, Settings, Archive, Trash2, MailOpen, Mail, RotateCcw, Edit, Reply, ReplyAll, Forward } from 'lucide-react';


import { API_BASE } from '../services/api';

const MailPage = ({
    activeFolder,
    filteredEmails,
    selectedEmails,
    isComposeOpen,
    selectedEmailId,
    setSelectedEmailId,
    handleRefresh,
    selectAll,
    handleAction,
    toggleSelect,
    toggleRead,
    markAsRead,
    toggleStar,
    setIsComposeOpen,
    addSentEmail,
    saveDraftEmail,
    handleReply,
    handleReplyAll,
    handleForward,

    handleEditDraft, // Add this new prop
    resetCompose,
    composeData,
    isLoading,
    isSyncing,
    loadedFolder,
    error,
    availableIdentities,
    user,
    onOpenRules
}) => {
    const [contextMenu, setContextMenu] = React.useState(null);

    const handleEmailContextMenu = (e, email) => {
        e.preventDefault();
        setContextMenu({
            x: e.clientX,
            y: e.clientY,
            email: email
        });
    };


    const selectedEmail = filteredEmails.find(e => e.id === selectedEmailId);

    const renderContent = () => {
        if (isComposeOpen) {
            return (
                <ComposeModal
                    user={user}
                    initialData={composeData}
                    availableIdentities={availableIdentities}
                    activeFolder={activeFolder}
                    onSend={(data) => {
                        addSentEmail(data);
                        resetCompose();
                    }}
                    onSaveDraft={(data) => {
                        saveDraftEmail(data);
                        resetCompose();
                    }}
                    onClose={() => resetCompose()}
                />
            );
        }

        if (selectedEmailId && selectedEmail) {
            // If the selected email is a draft, open it in compose mode instead of viewer
            if (activeFolder === 'Drafts') {
                handleEditDraft(selectedEmail);
                setSelectedEmailId(null); // Clear selection so it doesn't loop
                return null; // The compose modal will render on next cycle
            }

            return (
                <MailViewer
                    email={selectedEmail}
                    user={user}
                    onBack={() => setSelectedEmailId(null)}
                    onAction={(action) => {
                        handleAction(action, selectedEmail.id);
                        setSelectedEmailId(null);
                    }}
                    onReply={() => handleReply(selectedEmail)}
                    onReplyAll={() => handleReplyAll(selectedEmail)}
                    onForward={() => handleForward(selectedEmail)}

                    onContextMenu={(e) => handleEmailContextMenu(e, selectedEmail)}
                />
            );
        }

        return (
            <MailList
                activeFolder={activeFolder}
                filteredEmails={filteredEmails}
                selectedEmails={selectedEmails}
                handleRefresh={handleRefresh}
                selectAll={selectAll}
                handleAction={handleAction}
                onEmailClick={(id) => {
                    const email = filteredEmails.find(e => e.id === id);

                    // If clicking on a draft, open it in compose mode
                    if (activeFolder === 'Drafts' && email) {
                        handleEditDraft(email);
                    } else {
                        setSelectedEmailId(id);
                        if (email && !email.isRead) {
                            markAsRead(id);
                        }
                    }
                }}
                toggleSelect={toggleSelect}
                toggleRead={toggleRead}
                toggleStar={toggleStar}
                onEmailContextMenu={handleEmailContextMenu}
                isLoading={isLoading}
                isSyncing={isSyncing}
                loadedFolder={loadedFolder}
                error={error}
            />
        );
    };

    return (
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', position: 'relative' }}>
            {renderContent()}

            {contextMenu && (
                <ContextMenu
                    x={contextMenu.x}
                    y={contextMenu.y}
                    options={[
                        {
                            label: 'Reply',
                            icon: Reply,
                            onClick: () => {
                                handleReply(contextMenu.email);
                                setContextMenu(null);
                            }
                        },
                        {
                            label: 'Reply All',
                            icon: ReplyAll,
                            onClick: () => {
                                handleReplyAll(contextMenu.email);
                                setContextMenu(null);
                            }
                        },
                        {
                            label: 'Forward',
                            icon: Forward,
                            onClick: () => {
                                handleForward(contextMenu.email);
                                setContextMenu(null);
                            }
                        },
                        {
                            label: '---', // Separator
                            onClick: () => { }
                        },
                        // Show "Edit Draft" option if in Drafts folder

                        ...(activeFolder === 'Drafts' ? [{
                            label: 'Edit Draft',
                            icon: Edit,
                            onClick: () => {
                                handleEditDraft(contextMenu.email);
                                setContextMenu(null);
                            }
                        }] : []),
                        {
                            label: contextMenu.email.isRead ? 'Mark as Unread' : 'Mark as Read',
                            icon: contextMenu.email.isRead ? Mail : MailOpen,
                            onClick: () => toggleRead(contextMenu.email.id)
                        },
                        contextMenu.email.folder === 'Archive' ? {
                            label: 'Undo',
                            icon: RotateCcw,
                            onClick: () => handleAction('Undo', contextMenu.email.id)
                        } : contextMenu.email.folder === 'Trash' ? {
                            label: 'Restore',
                            icon: RotateCcw,
                            onClick: () => handleAction('Restore', contextMenu.email.id)
                        } : {
                            label: 'Archive',
                            icon: Archive,
                            onClick: () => handleAction('Archive', contextMenu.email.id)
                        },
                        {
                            label: 'Delete',
                            icon: Trash2,
                            onClick: () => handleAction('Trash', contextMenu.email.id),
                            danger: true
                        },
                        {
                            label: '---', // Separator
                            onClick: () => { }
                        },

                        {
                            label: 'Create Rule...',
                            icon: Shield,
                            onClick: () => onOpenRules()
                        },
                        {
                            label: 'Manage Rules',
                            icon: Settings,
                            onClick: () => onOpenRules()
                        }
                    ]}
                    onClose={() => setContextMenu(null)}
                />
            )}
        </div>
    );
};

export default MailPage;
